// test887
(887 && 0);
